<template>
  <div class="main">
    <div class="header">
      <div class="logo">
        <img
            v-if="ifMDandUp"
            class="logo-img-desktop"
            src="../static/bmclightlogo.png"
        />
        <img v-else class="logo-img-mobile" src="../static/smallBMClogo.png"/>
      </div>
      <!-- <v-spacer /> -->
      <!-- <div class="sign"> -->
      <!-- <button class="signin">SIGN IN</button>
      <button class="signup">SIGN UP</button> -->
      <!-- </div> -->
    </div>
    <div class="bottom-div">
      <div class="panel-container">
        <div class="title">
          <div class="goodmorning">Good morning</div>
          <div class="small-text">
            Sign in using the credentials you used during <br/>registering for
            an account
          </div>
        </div>
        <div class="panel">
          <!-- <div v-if="error" class="alert alert-danger">{{error}}</div> -->
          <div class="login">
            <div class="container">
              <div class="bold-text">Email address</div>
              <v-text-field
                  class="panel-textfiled"
                  id="email"
                  type="email"
                  name="email"
                  value
                  required
                  v-model="form.email"
              ></v-text-field>
              <div class="bold-text">Password</div>
              <v-text-field
                  id="password"
                  type="password"
                  name="password"
                  required
                  v-model="form.password"
                  @keyup.enter="submit()"
              ></v-text-field>

              <button @click="submit()" class="sign-button">Sign In</button>

              <!-- <div class="div-forgotpassword">
                <div
                  class="d-flex"
                  style="
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: flex-start;
                  "
                >
                  <v-checkbox></v-checkbox>
                  <input type="checkbox" class="remember-checkbox" style="" />
                  <button>remeber me?</button>
                </div>
                <div>forgot your password</div>
              </div> -->
            </div>
            <!-- <div>create account</div> -->
          </div>
        </div>
      </div>
      <div class="side-panel">
        <h3>Blockchain Made Certificate</h3>
        <div class="small-text">
          Document Verification and Authentication <br/>
          System based on Blockchain
        </div>
        <div class="footer-icons">
          <button><img src="../static/facebooklogo.png"/></button>
          <button><img src="../static/twitterlogo.png"/></button>
          <button><img src="../static/linkedinlogo.png"/></button>
        </div>
        <div class="footer">
          <div>
            <button>Privacy policy</button>
          </div>
          <div>
            <button>Terms of use</button>
          </div>
          <div>
            <button>Contacts</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
button :active {
  outline: none;
}

.main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-image: linear-gradient(
          189.27deg,
          rgba(42, 171, 243, 1),
          rgba(20, 130, 188, 0.8)
  ),
  url("../static/back.png");
  @media only screen and (max-width: 799px) {
    background: linear-gradient(
            189.27deg,
            rgba(42, 171, 243, 1),
            rgba(20, 130, 188, 0.8)
    );
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 45px 90px 0px 90px;
  @media only screen and (max-width: 799px) {
    padding: 33px 43px 0px 27px;
  }
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-img-desktop {
  width: 189px;
  height: 55px;
}

.logo-img-mobile {
  width: 56px;
  height: 39px;
}

.sign {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: white;
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  color: #ffffff;
  @media only screen and (max-width: 799px) {
    font-size: 12px;
    line-height: 14px;
  }
}

.signin {
  margin-right: 14px;
  @media only screen and (max-width: 799px) {
    margin-right: 22px;
  }
}

.signup {
  margin-left: 14px;
  @media only screen and (max-width: 799px) {
    margin-left: 22px;
  }
}

.title {
  padding-left: 90px;
  margin-bottom: 45px;
  font-family: "DM Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 28px;
  line-height: 36px;
  color: #f0f0f0;
  @media only screen and (max-width: 799px) {
    margin-bottom: 35px;
    padding-left: 27px;
  }
}

.title .goodmorning {
  padding-bottom: 3px;
  font-weight: bold;
  font-size: 28px;
  line-height: 36px;
  color: #f0f0f0;
  @media only screen and (max-width: 799px) {
    font-size: 30px;
    line-height: 39px;
  }

}

.title .small-text {
  padding-top: 3px;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  color: #e0e0e0;
  @media only screen and (max-width: 799px) {
    font-size: 14px;
    line-height: 17px;
  }
  @media only screen and (max-height: 599px) {
    display: none;
  }
}

.panel-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  min-width: 654px;
  max-width: 100%;
  @media only screen and (max-width: 799px) {
    min-width: 0;
    width: 100%;
    max-width: 100%;
  }
}

.panel {
  height: 450px;
  width: 100%;
  //max-height: 100%;
  background: #f9f9f9;
  border-radius: 41px 40px 0px 0px;
}

.login {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  padding: 90px 90px 53px 90px;
  @media only screen and (max-width: 799px) {
    padding: 56px 45px 36px 45px;
  }

  .container {
    box-sizing: border-box;
    width: 100%;
  }

  .sign-button {
    width: 100%;
    padding: 15px 0px;
    margin-bottom: 25px;
    background: #0796d0;
    border: 1px solid #f0f0f0;
    box-sizing: border-box;
    backdrop-filter: blur(4px);
    font-family: "DM Sans", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    /* identical to box height */
    color: #ffffff;
    /* Note: backdrop-filter has minimal browser support */
    border-radius: 5px;
  }

  .bold-text {
    font-family: "DM Sans", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    /* identical to box height */
    @media only screen and (max-width: 799px) {
      font-family: "Lato", sans-serif;
      font-size: 18px;
      line-height: 22px;
    }
    color: #000000;
  }

  .div-forgotpassword {
    display: flex;
    justify-content: space-between;
  }

  .remember-checkbox {
    width: 25px;
    height: 25px;
    margin-right: 8px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    box-sizing: border-box;
    border-radius: 5px;
  }

  .panel-textfiled {
    margin-bottom: 25px;
    @media only screen and (max-width: 799px) {
      margin-bottom: 35px;
    }
  }
}

.bottom-div {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-height: 30%;
  margin-top: 30%;
}

.side-panel {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 0 0 51px 71px;
  @media only screen and (max-width: 1200px) {
    display: none;
  }
  font-family: "DM Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  color: #ffffff;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 12px;
  }

  .small-text {
    font-size: 16px;
    line-height: 21px;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 35px;
  }

  .footer {
    display: flex;
    flex-direction: row;
    font-size: 12px;
    line-height: 16px;

    div {
      width: 114px;
    }
  }

  .footer-icons {
    display: flex;
    flex-direction: row;
    margin-bottom: 66px;

    button {
      margin-right: 25px;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }
}
</style>

<script>
import firebase from "firebase/app";
import {getAuth, signInWithEmailAndPassword} from "firebase/auth";
import {mapGetters, mapActions} from "vuex";
import store from "@/store";

export default {
  data() {
    return {
      checkbox: "",
      form: {
        email: "",
        password: "",
      },
      error: null,
    };
  },
  watch: {
    "$store.state.windowWidth"() {
      this.onResize();
    },
  },
  computed: {
    ...mapGetters({
      windowWidth: "windowWidth",
    }),
    ifMDandUp() {
      if (this.windowWidth > 799) return true;
      return false;
    },
  },
  methods: {
    onResize() {
      this.$store.dispatch('setWindowWidth')
    },
    submit() {
      const auth = getAuth();
      signInWithEmailAndPassword(auth, this.form.email, this.form.password)
          .then(() => {
            this.login = true;
            this.$router.push({name: "upload"});
          })
          .catch((err) => {
            this.error = err.message;
          });
    },
  },
};
</script>
